/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Category_PesticideInputs */

const vi_agri_category_pesticide = /** @type {(inputs: Agri_Category_PesticideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuốc bảo vệ thực vật`)
};

/**

* @param {Agri_Category_PesticideInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_category_pesticide = /** @type {((inputs?: Agri_Category_PesticideInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Category_PesticideInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_category_pesticide(inputs)
});